import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import CareersHero from "@/components/site/careers/CareersHero";
import WhyJoin from "@/components/site/careers/WhyJoin";
import Openings from "@/components/site/careers/Openings";
import ApplyCTA from "@/components/site/careers/ApplyCTA";
import ApplicationForm from "@/components/site/careers/ApplicationForm";
import { JOBS } from "@/data/jobs";

export default function CareersPage() {
  useEffect(() => {
    // Per-page SEO
    document.title = "Careers at Beacon IT Dev | Join Our Technology Team";
    const setMeta = (attr, name, content) => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "name",
      "description",
      "Explore career opportunities at Beacon IT Dev. Join our team of developers, engineers, frontend specialists and QA professionals building innovative technology solutions."
    );
    setMeta(
      "property",
      "og:title",
      "Careers at Beacon IT Dev | Join Our Technology Team"
    );
    setMeta(
      "property",
      "og:description",
      "Open roles for PHP, Node.js, React, UI/Frontend developers and QA at Beacon IT Dev — Pune, India."
    );
    setMeta("property", "og:url", "https://beaconitdev.com/careers");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://beaconitdev.com/careers");

    // JobPosting structured data — one JSON-LD block per job
    const scripts = JOBS.map((job) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-jobposting", job.id);
      s.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: job.title,
        description: `<p>${job.summary}</p><h3>Responsibilities</h3><ul>${job.responsibilities
          .map((r) => `<li>${r}</li>`)
          .join("")}</ul><h3>Required Skills</h3><ul>${job.skills
          .map((s2) => `<li>${s2}</li>`)
          .join("")}</ul>`,
        datePosted: new Date().toISOString().slice(0, 10),
        employmentType: job.employmentType,
        hiringOrganization: {
          "@type": "Organization",
          name: "Beacon IT Solution",
          sameAs: "https://beaconitdev.com",
        },
        jobLocation: {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Pune",
            addressRegion: "Maharashtra",
            addressCountry: "IN",
          },
        },
        experienceRequirements: {
          "@type": "OccupationalExperienceRequirements",
          monthsOfExperience: 12,
        },
        skills: job.skills.join(", "),
        applicantLocationRequirements: {
          "@type": "Country",
          name: "India",
        },
        directApply: true,
        url: `https://beaconitdev.com/careers#${job.slug}`,
      });
      document.head.appendChild(s);
      return s;
    });

    return () => {
      // Cleanup JSON-LD blocks when leaving the page
      scripts.forEach((s) => {
        if (s.parentNode) s.parentNode.removeChild(s);
      });
      // Reset title
      document.title =
        "Beacon IT Solution — Custom CRM, eCommerce, API & GoHighLevel Development, Pune";
    };
  }, []);

  return (
    <main
      data-testid="careers-page"
      className="bg-[color:var(--bg)] text-white overflow-hidden relative"
    >
      <Nav />
      <CareersHero />
      <WhyJoin />
      <Openings />
      <ApplyCTA />
      <ApplicationForm />
      <Footer />
    </main>
  );
}
